import { z } from 'zod'
import { formItemSchema } from './form-item'

export const datePickerSchema = formItemSchema.extend({
  type: z.literal('date-picker'),
  showTime: z.boolean().optional().describe('是否显示时间选择器'),
  showNow: z.boolean().optional().describe('显示当前日期时间的快捷选择'),
  showWeek: z.boolean().optional().describe('展示当前周'),
  utc: z.boolean().optional().describe('是否使用UTC时间'),
})

export type DatePickerSchema = z.infer<typeof datePickerSchema>
